import 'react-responsive-carousel/lib/styles/carousel.min.css'

import React, { useEffect, useRef, useState } from 'react'
import { Carousel } from 'react-responsive-carousel'

import { baseURL, baseURLImage } from '../../../api/api'
import { GenplanType, Slide } from '../../../store/project/types'
import { Container } from '../../Container/Container'
import styles from './projectCarousel.module.scss'

interface Slides {
  slides: Slide[]
  genplan: GenplanType
}

export const ProjectCarousel = ({ slides, genplan }: Slides) => {
  const duration = 5000
  const [activeIndex, setActiveIndex] = useState(0)
  const timeBarRefs = useRef<(HTMLDivElement | null)[]>([])
  const carouselRef = useRef<Carousel | null>(null)
  const [slidesList, setSlidesList] = useState<Slide[]>([])

  const handleSlideChange = (newIndex: number) => {
    if (newIndex === 0) {
      timeBarRefs.current.forEach(ref => ref && (ref.style.width = '0'))
    }

    setActiveIndex(newIndex)
    timeBarRefs.current
      .slice(0, newIndex)
      .forEach(ref => ref && (ref.style.width = '100%'))
  }

  function changeSlide(e: React.MouseEvent<HTMLElement>) {
    if (carouselRef.current) {
      carouselRef.current.moveTo(Number(e.currentTarget.dataset.index))
    }
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      const ref = timeBarRefs.current[activeIndex]
      if (ref) {
        const currentWidth =
          parseFloat(ref.style.width || '0') + 100 / (duration / 100)
        ref.style.width = `${Math.min(currentWidth, 100)}%`
      }
    }, 100)

    return () => clearInterval(intervalId)
  }, [activeIndex, duration])

  useEffect(() => {
    const newArray = [...slides]
    if (genplan) {
      newArray.splice(1, 0, genplan)
    }

    setSlidesList([...newArray])
  }, [slides, genplan])

  return (
    <div className={styles.head}>
      {slides.length > 0 && (
        <Carousel
          ref={carouselRef}
          autoPlay
          infiniteLoop
          showThumbs={false}
          showStatus={false}
          showIndicators={false}
          showArrows={false}
          interval={duration}
          selectedItem={activeIndex}
          onChange={handleSlideChange}
          stopOnHover={false}
          className={styles.head__slider}
          swipeable={false}
        >
          {slidesList.map(slide => (
            <div key={slide.ORIGINAL_NAME} className={styles.carouselSlide}>
              <img src={`${baseURLImage}${slide.SRC}`} alt='Слайд' />
            </div>
          ))}
        </Carousel>
      )}

      <Container>
        <div className={styles.head__container}>
          <div className={styles.timeBarsContainer}>
            {slidesList.map((_, index) => (
              <div
                key={index}
                className={styles.timeBar}
                data-index={index}
                onClick={changeSlide}
              >
                <div
                  ref={el => (timeBarRefs.current[index] = el)}
                  className={styles.timeBarFill}
                  style={{ width: index < activeIndex ? '100%' : '0' }}
                />
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}
